import React from 'react';

import { Route, Redirect, Switch, } from 'react-router-dom'
import './App.scss';

import EsignPage from './pages/esign/esign.component'
import VerifyPage from './pages/verify/verify.component';
import Header from './components/header/header.component';
import Footer from './components/footer/footer.component';

import ErrorContainer from './components/error/error.container';
import ValidateDocument from './components/validate-document/validate-document.component';
import VerifyDocumentCredibility from './components/verify-document-credibility/verify-document-credibility.component';

import ErrorPage from './pages/error/error.page';
import PrivacyPage from './pages/privacy/privacy.component';

const NoMatch = () => <div>Not found</div>


function App() {
  return (
    <div className="App">    
      <Header />
      <ErrorContainer />
      <div className="container">
        <div className="content">
          <Switch>
            <Route exact path="/">
              <Redirect to="/epotpis" />
            </Route>
            <Route path="/epotpis" component={EsignPage} />
            <Route path="/error" component={ErrorPage} />
            <Route exact path="/validacija" component={ValidateDocument} />
            <Route path="/provjera/:verificationCode" component={VerifyDocumentCredibility} />
            <Route exact path="/provjera/" component={VerifyPage} />
            <Route exact path="/privacy-policy-v2" component={PrivacyPage} />
            <Route path="*" component={NoMatch} status={404}/>
          </Switch>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default App;
